export const PLATFORM_ROLES = [
  "platform_admin",
  "billing_admin",
  "account_manager",
  "support",
] as const;

export type PlatformRole = (typeof PLATFORM_ROLES)[number];

/**
 * Named constants for every platform role, kept as a complete set even when a role has no
 * direct code reference yet.
 * @public
 */
export const [
  PLATFORM_ADMIN_ROLE,
  BILLING_ADMIN_ROLE,
  ACCOUNT_MANAGER_ROLE,
  SUPPORT_ROLE,
] = PLATFORM_ROLES;
